/**
 * @updated		10.03.2025.
 *
 * @note_1 to work properly, add `devnet-plugin-settings-page` class to
 * settings page wrapper.
 * @note_2 to work properly, add `data-id` attribute to
 * settings page wrapper.
 */

jQuery(document).ready(function () {
	const $ = jQuery;

	const state = {
		group: {},
	};

	const activeClass = 'dvnt-active';
	const tabActiveClass = 'nav-tab-active';

	/**
	 * Check if this is the settings page.
	 *
	 */
	const $settingsPage = $('.devnet-plugin-settings-page');

	if (!$settingsPage.length) {
		return false;
	}

	const ID = $settingsPage.data('id');

	/**
	 * Check if nav tabs contains at least one ID that starts with "devnet_".
	 *
	 */
	// // Get all ids into an array
	// const devnetIds = $('.nav-tab-wrapper a')
	// 	.map(function () {
	// 		return $(this).attr('id');
	// 	})
	// 	.get()
	// 	.some((id) => id && id.startsWith('devnet_'));

	// if (!devnetIds) {
	// 	return false;
	// }

	//Initiate Color Picker
	$('.wp-color-picker-field').wpColorPicker();

	const activeTabName = ID ? `${ID}_activetab` : 'activetab';
	const activeInnerTabName = ID ? `${ID}_activetab_inner` : 'activetab';

	// Switches option sections
	$('.group').hide();

	let activeTab = '';
	let activeTabInner = '';

	if (typeof localStorage !== 'undefined') {
		activeTab = localStorage.getItem(activeTabName);
		activeTabInner = localStorage.getItem(activeInnerTabName);
	}

	// If URL has section ID as hash, set it as active or override local storage
	if (window.location.hash) {
		activeTab = window.location.hash;
		if (typeof localStorage !== 'undefined') {
			localStorage.setItem(activeTabName, activeTab);
		}
	}

	// Activate the correct top-level tab
	if (activeTab && $(activeTab + '-tab').length) {
		$(activeTab + '-tab').addClass('nav-tab-active');
	} else {
		$('.nav-tab-wrapper a:first').addClass('nav-tab-active');
	}

	// Show the corresponding content
	if (activeTab && $(activeTab).length) {
		$(activeTab).addClass(activeClass).fadeIn();

		// Handle inner tabs
		if (activeTabInner && $(`${activeTab} ${activeTabInner}-tab`).length) {
			$(`${activeTab} ${activeTabInner}-tab`).addClass(tabActiveClass);
			$(`${activeTab} ${activeTabInner}`).addClass(activeClass).fadeIn();
		} else {
			$(`${activeTab} .inner-tab:first`).addClass(tabActiveClass);
			$(`${activeTab} .group:first`).addClass(activeClass).fadeIn();
		}
	} else {
		$('.group:first').addClass(activeClass).fadeIn();
	}

	$(document).on('click', '.nav-tab-wrapper a', function (evt) {
		const $clickedTab = $(this);
		const hasInnerTabs = $clickedTab.hasClass('has-tabs');
		const isInnerTab = $clickedTab.hasClass('inner-tab');
		const clicked_group = $clickedTab.attr('href');

		if ($clickedTab.hasClass(tabActiveClass)) {
			return false;
		}

		if (isInnerTab) {
			if (typeof localStorage !== 'undefined') {
				localStorage.setItem(activeInnerTabName, clicked_group);
			}

			// INNER TAB HANDLING: Only affect tabs inside the same .has-tabs container
			const $parentHasTabs = $clickedTab.closest('.has-tabs');

			$parentHasTabs
				.find('.nav-tab-wrapper a')
				.removeClass(tabActiveClass);
			$clickedTab.addClass(tabActiveClass).blur();

			// Hide only the inner groups inside this .has-tabs
			$parentHasTabs.find('.group').hide().removeClass(activeClass);
			$parentHasTabs.find(clicked_group).addClass(activeClass).fadeIn();
		} else {
			if (typeof localStorage !== 'undefined') {
				localStorage.setItem(activeTabName, clicked_group);
			}

			$clickedTab.addClass(tabActiveClass).blur();

			// Hide all top-level .group elements except the clicked one
			$('.group').hide().removeClass(activeClass);
			$(clicked_group).addClass(activeClass).fadeIn();

			// TOP-LEVEL TAB HANDLING
			if (hasInnerTabs) {
				$('.nav-tab-wrapper a')
					.not('.has-tabs')
					.not('.inner-tab')
					.removeClass(tabActiveClass);

				$(`${clicked_group} .inner-tab:first`).addClass(tabActiveClass);
				$(`${clicked_group} .group:first`).addClass(activeClass);
				$(`${clicked_group} .group:first`).fadeIn();
			} else {
				$('.nav-tab-wrapper a').removeClass(tabActiveClass);
				$clickedTab.addClass(tabActiveClass);
			}
		}

		evt.preventDefault();
	});

	$('.group .collapsed').each(function () {
		$(this)
			.find('input:checked')
			.parent()
			.parent()
			.parent()
			.nextAll()
			.each(function () {
				if ($(this).hasClass('last')) {
					$(this).removeClass('hidden');
					return false;
				}
				$(this).filter('.hidden').removeClass('hidden');
			});
	});

	$(document).on('click', '.dvnt-f-browse', function (event) {
		event.preventDefault();

		const self = $(this);

		// Create the media frame.
		const file_frame = (wp.media.frames.file_frame = wp.media({
			title: self.data('uploader_title'),
			button: {
				text: self.data('uploader_button_text'),
			},
			multiple: false,
		}));

		file_frame.on('select', function () {
			attachment = file_frame.state().get('selection').first().toJSON();
			self.prev('.dvnt-f-url').val(attachment.url).change();

			if (attachment.type === 'image') {
				self.parent()
					.find('.dvnt-f-preview')
					.attr('src', attachment.url);
			}
		});

		// Finally, open the modal
		file_frame.open();
	});

	const infoRows = $('tr.info');
	infoRows.map((_, row) => {
		const $row = $(row);
		const infoLabel = $row.find('label').text();
		const infoDesc = $row.find('.info-description').html();

		$row.html(`
		<td colspan="2">
			<span class="info-title">${infoLabel}</span>
			<span class="info-description">${infoDesc}</p>
		</td>
		`);
	});

	$('.info-description input').on('click', function () {
		$(this).select();
	});

	const repeatableGroups = $('.dvnt-groups').data('repeatable');

	const indexUpdate = (attr, index) => {
		return attr.replace(/(\[\d+])/, '[' + index + ']');
	};

	// Function to update the index of each group
	function updateGroupIndexes(element) {
		element
			.closest('.dvnt-groups')
			.find('.dvnt-group')
			.each(function (newIndex) {
				$(this)
					.find('[name], [id], [for]')
					.each(function () {
						const $this = $(this);
						const attrName = $this.attr('name');
						const attrId = $this.attr('id');
						const attrFor = $this.attr('for');

						// Update only existing attributes
						if (attrName) {
							$this.attr('name', indexUpdate(attrName, newIndex));
						}
						if (attrId) {
							$this.attr('id', indexUpdate(attrId, newIndex));
						}
						if (attrFor) {
							$this.attr('for', indexUpdate(attrFor, newIndex));
						}
					});
			});
	}

	$(document).on('click', '.dvnt-repeat-group', function (event) {
		event.preventDefault();

		const groupsWrapper = $(this).closest('.dvnt-groups');
		let newGroup = groupsWrapper.find('.dvnt-group').first().clone();

		if (!newGroup.length) {
			newGroup = state.group.show();
		}

		const newIndex = $('.dvnt-group').length;

		newGroup.find('[name], [id], [for]').each(function () {
			const $this = $(this);

			const attrName = $this.attr('name');
			const attrId = $this.attr('id');
			const attrFor = $this.attr('for');
			const attrChecked = $this.attr('checked');

			// Update only existing attributes
			if (attrName) {
				$this.attr('name', indexUpdate(attrName, newIndex));
			}
			if (attrId) {
				$this.attr('id', indexUpdate(attrId, newIndex));
			}
			if (attrFor) {
				$this.attr('for', indexUpdate(attrFor, newIndex));
			}

			// Reset value except on `select` element.
			if (this.value !== undefined && this.nodeName !== 'SELECT') {
				$(this).val('');
				$(this).attr('value', '');
			}

			if (attrChecked) {
				$this.prop('checked', false);
				$(this).val('1');
			}

			// Clear and reset Select2
			if ($this.hasClass('select2-hidden-accessible')) {
				$this.empty();

				const select2Group = $this.parent();

				// Find all child elements of select2Group
				const childElements = select2Group.children();

				// Loop through the child elements and filter out select and label
				childElements.each(function () {
					const tagName = $(this).prop('tagName').toLowerCase();

					if (tagName !== 'select' && tagName !== 'label') {
						$(this).remove();
					}
				});
			}
		});

		newGroup.find('.dvnt-f-preview').attr('src', '');

		$(this).before(newGroup);

		updateGroupIndexes($(this));
	});

	$(document).on('click', '.dvnt-remove-group', function (e) {
		e.preventDefault();

		if (confirm('Are you sure?')) {
			const $this = $(this);

			const group = $this.parent('.dvnt-group');

			// save group for easier repetition if no groups are left.
			state.group = group;

			group.fadeOut(function () {
				group.remove();
			});

			updateGroupIndexes($this);
		}
	});

	const attachClass = 'attach-units-to--';
	const $unitsSelector = $(`[class^="${attachClass}"]`).get();

	if ($unitsSelector.length) {
		$unitsSelector.forEach((row) => {
			// Convert the element to a jQuery object to use jQuery methods

			const $row = $(row);

			const classes = $row.attr('class').split(/\s+/); // Split classes by whitespace

			const $selectElement = $row.find('select');

			// Iterate over each class to find our target
			classes.forEach((className) => {
				if (className.startsWith(attachClass)) {
					// Extract the specific portion of the class name
					const attachTo = className.substring(attachClass.length);

					const $attachToRow = $(`tr.${attachTo}`);

					if ($attachToRow.length && $selectElement.length) {
						$attachToRow.addClass('has-unit-selector');

						const detached = $selectElement.detach();
						$attachToRow.find('input').after(detached);

						$row.remove();
					}
				}
			});
		});
	}
});
